import React from 'react'
import { Link } from 'react-router-dom'
import { SEOHead } from '../components/ui/SEOHead'
import { TerminalWindow } from '../components/terminal/TerminalWindow'
import { TerminalPrompt } from '../components/terminal/TerminalPrompt'

export const NotFoundPage: React.FC = () => {
  return (
    <>
      <SEOHead title="404 Not Found" description="Page not found" />

      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '60px 0',
        }}
      >
        <div style={{ maxWidth: '540px', width: '100%' }}>
          <TerminalWindow title="error.sh">
            <div
              style={{
                fontFamily: "'JetBrains Mono', 'Courier New', monospace",
                fontSize: '0.88rem',
                lineHeight: '1.8',
              }}
            >
              {/* Command line */}
              <div style={{ marginBottom: '16px' }}>
                <TerminalPrompt path="~" command="locate page" />
              </div>

              {/* Error output */}
              <div
                style={{
                  color: 'var(--accent-red, #ff4444)',
                  marginBottom: '8px',
                  fontSize: '1.1rem',
                  fontWeight: 700,
                }}
              >
                Error 404: page not found
              </div>
              <div style={{ color: 'var(--text-secondary)', marginBottom: '24px' }}>
                The requested resource does not exist on this server.
                <br />
                It may have been moved, deleted, or never existed.
              </div>

              {/* Suggestions */}
              <div
                style={{
                  color: 'var(--text-muted, #555)',
                  fontSize: '0.8rem',
                  marginBottom: '20px',
                  borderTop: '1px solid var(--border-color)',
                  paddingTop: '16px',
                }}
              >
                Suggestions:
                <ul style={{ paddingLeft: '1.25rem', marginTop: '8px', lineHeight: '2' }}>
                  <li>Check the URL for typos</li>
                  <li>Return to the homepage</li>
                  <li>Use search to find what you need</li>
                </ul>
              </div>

              {/* Navigation */}
              <div style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
                <Link
                  to="/"
                  style={{
                    color: 'var(--accent-green)',
                    textDecoration: 'none',
                    fontSize: '0.85rem',
                    border: '1px solid var(--accent-green)',
                    padding: '5px 12px',
                    borderRadius: '3px',
                    transition: 'background-color 0.15s',
                  }}
                >
                  [cd ~]
                </Link>
                <Link
                  to="/search"
                  style={{
                    color: 'var(--accent-cyan)',
                    textDecoration: 'none',
                    fontSize: '0.85rem',
                  }}
                >
                  [search posts]
                </Link>
              </div>

              {/* Prompt */}
              <div style={{ marginTop: '24px' }}>
                <TerminalPrompt path="~" showCursor={true} />
              </div>
            </div>
          </TerminalWindow>
        </div>
      </div>
    </>
  )
}
